<div *ngIf="renderPreview === true" class="widget-preview">
    <h3>{{componentName}}</h3>
    <img [src]="this.componentImg" />
</div>
<div *ngIf="renderPreview === false" class="widget-render grid">
    <!-- <ng-container *ngComponentOutlet="getComponent()" />  -->
</div>                          